import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import ChildHeader from 'components/Dashboard/Main/ChildHeader';
import { Box, Button, Center, Flex, Grid, Image, Skeleton, Text, VStack } from '@chakra-ui/react';
import Pagamento from '../../../images/Pagamento.svg';
import { getAppTheme, userIsSubscriber } from '../../Utils/theme';
import { AccountContext } from '../../AccountContext';

function SucessoPagamento() {
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      navigate('/dashboard');
    }, 400);
  }, []);
  const { user } = useContext(AccountContext);
  const theme = getAppTheme(userIsSubscriber(user));
  return (
    <>
      <ChildHeader />
      <Box display="flex" justifyContent="center" alignItems="center" w="100%" minHeight="50vh" flexDirection="column">
        <VStack w={'100%'} justifyContent="center" alignItems="center">
          <Box bg={'#F3F3F3'} w={'80%'} align={'center'} p={4} borderRadius={'0.8em'}>
            <Image src={Pagamento} alt="Pagamento" />
            <Text color={'#585858'} fontWeight={'bold'} fontSize={'20px'} mt={2}>
              Seu <span style={{ color: '#5AB2AE' }}>pagamento</span> foi <br /> realizado com <span style={{ color: '#5AB2AE' }}>sucesso</span>.
            </Text>
          </Box>
        </VStack>
      </Box>
    </>
  );
}

export default SucessoPagamento;
